import { render, staticRenderFns } from "./PaymentMethodViewLogs.vue?vue&type=template&id=08cb1805"
import script from "./PaymentMethodViewLogs.vue?vue&type=script&lang=js"
export * from "./PaymentMethodViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports